import BaseTable from './BaseTable';


class SpecialtyTable extends BaseTable {

}

export default SpecialtyTable;
